var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSelectAllTool = function SvgSelectAllTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#707070",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 30h2v-2h-2v2zM8.23 30h2.124v-2H8.23v2zm4.354 0h2.124v-2h-2.124v2zm4.354 0h2.124v-2h-2.124v2zm4.354 0h2.124v-2h-2.124v2zm4.354 0h2.124v-2h-2.124v2zM4 30h2v-2H4v2zM4 9.991h2V8.044H4v1.947zm0 3.991h2v-1.947H4v1.947zm0 3.991h2v-1.947H4v1.947zm0 3.991h2v-1.947H4v1.947zm0 3.992h2v-1.947H4v1.947zM4 6h2V4H4v2zm4.23 0h2.124V4H8.23v2zm4.354 0h2.124V4h-2.124v2zm4.354 0h2.124V4h-2.124v2zm4.354 0h2.124V4h-2.124v2zm4.354 0h2.124V4h-2.124v2zM30 6h2V4h-2v2zm0 3.991h2V8.044h-2v1.947zm0 3.991h2v-1.947h-2v1.947zm0 3.992h2v-1.947h-2v1.947zm0 3.991h2v-1.947h-2v1.947zm0 3.991h2v-1.947h-2v1.947z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 26h-9v-8h9v8zm-4.65-6.65h-3v5.3h6.3v-2l-3.3-3.3zM17 26H8v-8h9v8zm-4.65-6.65h-3v5.3h6.3v-2l-3.3-3.3zM28 16H8V8h20v8zm-4.65-6.65h-14v5.3h17.3v-2l-3.3-3.3z",
    fillRule: "nonzero"
  }))));
};

export default SvgSelectAllTool;